import React, { useEffect } from 'react';
import './sell.scss';

import SEO from '../../components/seo/SEO';
import { Icon, Icons } from '../../components';
import InfoText from '../../components/info-text/Infotext';
import SellCalculator from '../../components/sell-calculator/sell-calculator';

export default function Sell() {
  return (
    <>
      <SEO title="Sälj enkelt din sportutrustning hos Sportbytarboden - Sportbytarboden"></SEO>
      <section className="sell-info">
        <InfoText
          heading={'Hur fungerar det?'}
          description={'Sälj enkelt i 5 steg – slipp allt krångel!'}
        ></InfoText>
        <div style={{ marginBottom: 40 }} className="sell-info-tips pt-8">
          <div className="tip-container">
            <div className="tip-icon tip-icon-one">1</div>
            <div className="tip-text-container">
              <h3>Samla ihop de du vill sälja</h3>
              <p>
                Samla den sport- och idrottsutrustning du vill sälja. Se till
                att allt är helt, rent, modernt och att vi tar emot varorna."
                Vad tar vi emot?
              </p>
              <div className="tips-container">
                <div className="tips-icon">
                  <Icon icon={Icons.faLightbulb} size={'xl'} />
                </div>
                <div className="tips-text-container">
                  <h4>Vad tar vi emot till försäljning?</h4>
                  <ul>
                    <li>
                      Alpinutrustning (pjäxor, skidor, snowboards,
                      snowboardboots)
                    </li>
                    <li> Längdutrustning</li>
                    <li> Hockeyutrustning</li>
                    <li> Skridskor och rullskridskor</li>
                    <li> Golfutrustning</li>
                    <li> Cyklar</li>
                  </ul>
                  <p>
                    Utrustningen ska vara hel, ren och komplett – inga saknade
                    delar.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="tip-container">
            <div className="tip-icon">2</div>
            <div className="tip-text-container">
              <h3>Besök vår butik </h3>
              <p>
                Ta med den utrustning du vill sälja till vår butik. Vår kunniga
                personal hjälper dig gärna med inlämningen och finns där för att
                ge bästa möjliga service. Du hittar mer information och
                öppettider <a href="/butik">här!</a>
              </p>
              <div className="tips-container">
                <div className="tips-icon">
                  <Icon icon={Icons.faLightbulb} size={'xl'} />
                </div>
                <div className="tips-text-container">
                  <h4>Pris</h4>
                  <p>
                    Vi har lång erfarenhet av att sälja begagnad sportutrustning
                    och hjälper dig gärna att sätta ett rättvist pris på dina
                    varor. Om varan är ny kan det vara bra om du har koll på
                    inköpspriset.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="tip-container">
            <div className="tip-icon">3</div>
            <div className="tip-text-container">
              <h3>Försäljning av dina varor</h3>
              <p>
                Låt oss ta hand om försäljningsprocessen! Vi ser till att dina
                varor får ett nytt hem, vilket både gynnar miljön och din
                plånbok. Sportbytarboden tar 40% i kommission av
                försäljningspriset upp till 4000 kr (vilket innebär en
                maxkommission på 1600 kr).
              </p>
            </div>
          </div>
          <SellCalculator></SellCalculator>
          <div className="tip-container">
            <div className="tip-icon">4</div>
            <div className="tip-text-container">
              <h3>Pengar direkt till ditt bankkonto</h3>
              <p>
                Vi betalar ut ersättningen för varje såld vara månaden efter att
                den är såld. Under högsäsong betalar vi ut till över 2 000 nöjda
                kunder varje månad.
              </p>
            </div>
          </div>
          <div className="tip-container">
            <div className="tip-icon">5</div>
            <div className="tip-text-container">
              <h3>Om din vara inte blev såld</h3>
              <p>
                De flesta varor hittar snabbt ett nytt hem, men om din vara inte
                är såld inom 12 månader ser vi till att den tas om hand på bästa
                sätt. Vi skickar det vi inte får sålt till välgörenhet eller
                återvinning.
              </p>
              <a href="/villkor">Läs våra säljvillkor här</a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
